module.exports = __webpack_public_path__ + "img/reference43.10b57eb7.jpg";